export default function CTASection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="contact"
      className="bg-[#F7F8FA] py-24 px-6 md:px-10"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-[24px] overflow-hidden border border-[#E5E7EB]"
          style={{ boxShadow: "0 16px 60px rgba(0,0,0,0.08)" }}
        >
          {/* Background image */}
          <div className="absolute inset-0 pointer-events-none">
            <img
              src="https://public.readdy.ai/ai/img_res/1ec9046026b8592a7131e9fb3fc06d29.jpg"
              alt=""
              className="w-full h-full object-cover object-center opacity-40"
            />
          </div>
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: "radial-gradient(ellipse 90% 80% at 50% 50%, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.96) 70%)",
            }}
          />

          {/* Grid overlay */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage:
                "linear-gradient(rgba(79,70,229,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(79,70,229,0.03) 1px, transparent 1px)",
              backgroundSize: "40px 40px",
            }}
          />

          <div className="relative z-10 text-center px-8 py-20">
            <p className="text-xs font-medium text-[#4F46E5] uppercase tracking-widest mb-5">
              Get Started
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1F2933] tracking-[-0.03em] leading-[1.08] mb-5">
              Install Your
              <br />
              Execution System
            </h2>
            <p className="text-sm md:text-base text-[#6B7280] leading-relaxed max-w-lg mx-auto mb-12">
              Start building a system that runs your operations with precision and consistency—without the manual overhead.
            </p>

            {/* Proof chips */}
            <div className="flex flex-wrap justify-center gap-3 mb-10">
              {["No-code setup", "Deployed in days", "Built for your industry", "Ongoing support"].map((chip) => (
                <span
                  key={chip}
                  className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white border border-[#E5E7EB] text-xs font-medium text-[#374151]"
                >
                  <i className="ri-check-line text-[#4F46E5] text-xs"></i>
                  {chip}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => scrollTo("contact-form")}
                className="px-9 py-4 bg-[#4F46E5] text-white text-sm font-medium rounded-[12px] hover:bg-[#4338CA] hover:shadow-[0_8px_28px_rgba(79,70,229,0.40)] hover:-translate-y-0.5 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Get Started
              </button>
              <button
                onClick={() => scrollTo("contact-form")}
                className="px-9 py-4 bg-white text-[#1F2933] text-sm font-medium rounded-[12px] border border-[#E5E7EB] hover:border-[#D1D5DB] hover:shadow-[0_4px_18px_rgba(0,0,0,0.08)] hover:-translate-y-0.5 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-calendar-line text-sm"></i> Schedule a Call
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
